"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _style = _interopRequireDefault(require("./style.css"));
var _DropdownList = _interopRequireDefault(require("react-widgets/lib/DropdownList"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _find2 = _interopRequireDefault(require("lodash/find"));
var _warning = _interopRequireDefault(require("cccisd-icons/warning"));
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var ClientToolbar = exports["default"] = /*#__PURE__*/function (_React$Component) {
  _inherits(ClientToolbar, _React$Component);
  function ClientToolbar() {
    var _this;
    _classCallCheck(this, ClientToolbar);
    _this = _callSuper(this, ClientToolbar);
    _defineProperty(_assertThisInitialized(_this), "onClientChange", function (client) {
      _this.props.onClientChange(client);
    });
    _defineProperty(_assertThisInitialized(_this), "renderReadOnly", function () {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].toolbar + " ".concat(_this.props.className)
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].clientBox
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].clientTitle
      }, /*#__PURE__*/_react["default"].createElement("b", null, "Current ", _this.props.clientType, ":")), /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].picker
      }, /*#__PURE__*/_react["default"].createElement("div", null, (0, _get2["default"])(_this.props.activeClient, _this.props.textFieldPath)))), /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].fieldBox
      }, _this.props.fields.map(function (f, index) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          key: index,
          style: {
            marginRight: '20px'
          }
        }, /*#__PURE__*/_react["default"].createElement("b", null, f.label, ":"), " ", f.value);
      })));
    });
    _defineProperty(_assertThisInitialized(_this), "renderInteractive", function () {
      var render = /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].toolbar + " ".concat(_this.props.className)
      }, /*#__PURE__*/_react["default"].createElement(_warning["default"], {
        spaceRight: true
      }), "No active ", "".concat(_this.props.clientType.toLowerCase(), "s"), " at this time");
      if (_this.props.clients.length > 0) {
        render = /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].toolbar + " ".concat(_this.props.className)
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].clientBox,
          style: {
            width: '40%'
          }
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].clientTitle
        }, "Current ", _this.props.clientType, ":"), /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].picker
        }, /*#__PURE__*/_react["default"].createElement(_DropdownList["default"], {
          value: (0, _find2["default"])(_this.props.clients, function (c) {
            return (0, _get2["default"])(c, _this.props.valueFieldPath) === (0, _get2["default"])(_this.props.activeClient, _this.props.valueFieldPath);
          }),
          data: _this.props.clients,
          textField: function textField(item) {
            return (0, _get2["default"])(item, _this.props.textFieldPath);
          },
          onChange: _this.onClientChange
        }))), /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].fieldBox,
          style: {
            width: '60%'
          }
        }, _this.props.fields.map(function (f, index) {
          return /*#__PURE__*/_react["default"].createElement("div", {
            key: index,
            style: {
              marginRight: '20px'
            }
          }, /*#__PURE__*/_react["default"].createElement("b", null, f.label, ":"), " ", f.value);
        })));
      }
      return render;
    });
    _this.state = {
      // state
    };
    return _this;
  }
  _createClass(ClientToolbar, [{
    key: "render",
    value: function render() {
      if (this.props.isLoading) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].toolbarContainer
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].toolbar + " ".concat(this.props.className)
        }, /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
          loading: true
        })));
      }
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].toolbarContainer
      }, !this.props.isReadOnly && this.renderInteractive(), this.props.isReadOnly && this.renderReadOnly());
    }
  }]);
  return ClientToolbar;
}(_react["default"].Component);
_defineProperty(ClientToolbar, "propTypes", {
  clients: _propTypes["default"].array.isRequired,
  activeClient: _propTypes["default"].object.isRequired,
  textFieldPath: _propTypes["default"].string.isRequired,
  valueFieldPath: _propTypes["default"].string,
  clientType: _propTypes["default"].string.isRequired,
  /**
   * [
   *     {
   *         label: "Some Label",
   *         value: "some value"
   *     }
   * ]
   *
   */
  fields: _propTypes["default"].array,
  onClientChange: _propTypes["default"].func,
  isLoading: _propTypes["default"].bool,
  isReadOnly: _propTypes["default"].bool,
  className: _propTypes["default"].string
});
_defineProperty(ClientToolbar, "defaultProps", {
  valueFieldPath: 'pawn.pawnId',
  isReadOnly: false,
  className: 'container'
});